import { getTestNode, handleTestSelection } from "./testSelection";
import { removeItem } from "./index.js";

export function addSelectedDiscountPanel(panelId, selectProp, supportObj) {
  let { selectedDiscountPanelIdList } = supportObj;
  if (selectedDiscountPanelIdList.includes(panelId)) {
    return false;
  }
  // check if the bundle is already inside a selected shortcut
  if (isBundleInSelectedShortcut(panelId, supportObj)) {
    return false;
  }
  // check if the bundle is already inside a selected custom panel
  if (isBundleInSelectedCustomPanel(panelId, supportObj)) {
    return false;
  }
  // select discountPanel and its content
  handleDiscountPanelSelection(panelId, selectProp, true, supportObj);
  // add it to selected discount panel list
  selectedDiscountPanelIdList.push(panelId);
  return true;
}

export function removeSelectedDiscountPanel(panelId, selectProp, supportObj) {
  let { selectedDiscountPanelIdList, bundleList, selectedCustomPanelIdList, selectedXChooseYPanelIdList, selectedTestIdList, seasonalPromotionList, selectedSeasonalPromoList, shortcutList, selectedShortcutIdList } = supportObj;
  let discountPanel = bundleList.find(b => b.bundleId === panelId);
  if (!discountPanel) {
    return;
  }
  // current discount panel is selected earlier
  if (selectedDiscountPanelIdList.includes(panelId)) {
    // remove panel itself
    removeItem(panelId, selectedDiscountPanelIdList);
    discountPanel[selectProp] = false;
  }
  else {
    // current discount panel belongs to any seasonal promo
    selectedSeasonalPromoList.forEach(promo => {
      if (promo.appliedBundles.has(discountPanel.bundleId)) {
        // de-select promo
        promo[selectProp] = false;
        // remove current promo
        removeItem(promo, selectedSeasonalPromoList);
        console.log(promo.appliedTests)
        // add remaining tests and bundles
        promo.appliedTests.forEach(testId => {
          selectedTestIdList.push(testId);
        });
        let bundleIdSet = new Set(promo.appliedBundles);
        bundleIdSet.delete(discountPanel.bundleId);
        bundleIdSet.forEach(bundleId => {
          selectedDiscountPanelIdList.push(bundleId);
        });
      }
    })

    // current discount panel belongs to any custom panel
    let selectedCustomPanelList = bundleList
      .filter(b => selectedCustomPanelIdList.includes(b.bundleId));
    selectedCustomPanelList.forEach(customPanel => {
      removeDiscountPanelInCustomPanel(panelId, customPanel, selectProp, customPanel.bundleId, selectedCustomPanelIdList, supportObj);
    });

    // current discount panel belongs to any shortcuts
    let selectedShortcutList = shortcutList
      .filter(shortcut => selectedShortcutIdList.includes(shortcut.id));
    selectedShortcutList.forEach(shortcut => {
      removeDiscountPanelInShortcut(panelId, shortcut, selectProp, shortcut.id, selectedShortcutIdList, supportObj);
    });    
  }
  // remove all tests and packages in this panel
  handleDiscountPanelSelection(panelId, selectProp, false, supportObj);

  if (selectProp === "isSelect") {
    removeDiscountPanelInEditOrder(panelId, supportObj);
  }
}

// select or de-select discount panel according to isSelectPanel value
export function handleDiscountPanelSelection(panelId, selectProp, isSelectPanel, supportObj) {
  let { bundleList, testNodeList } = supportObj;
  let discountPanel = bundleList.find(p => p.bundleId === panelId);
  if (discountPanel) {
    if (discountPanel.category === "xChooseY") {
      return;
    }
    discountPanel[selectProp] = isSelectPanel;
    // select all package and test belong to this panel
    let { packageList, testList } = discountPanel.bundleContent;
    let idList = (packageList ? packageList.map(p => p.packageId) : [])
        .concat(testList ? testList.map(t => t.testId): []);
    idList.forEach(id => {
      let node = getTestNode(testNodeList, id);
      handleTestSelection(node, selectProp, isSelectPanel);
    });
  }
}

function removeDiscountPanelInEditOrder(panelId, supportObj) {
  let { editOrderItemList, bundleList, shortcutList } = supportObj;
  let discountPanel = editOrderItemList.find(item => item.item_id === panelId && item.category === "discountPanel");
  removeItem(discountPanel, editOrderItemList);

  // discount panel belongs to any custom panels in edit order
  editOrderItemList.filter(item => item.category === "customPanel").forEach(customPanel => {
    let customPanelOnMenu = bundleList.find(bundle => bundle.bundleId === customPanel.item_id);
    removeDiscountPanelInCustomPanel(panelId, customPanelOnMenu, "isSelect", customPanel, editOrderItemList, supportObj);
  });

  // discount panel belongs to any shortcut in edit order
  editOrderItemList.filter(item => item.category === "shortcut").forEach(shortcut => {
    let shortcutOnMenu = shortcutList.find(s => s.id === shortcut.item_id);
    removeDiscountPanelInShortcut(panelId, shortcutOnMenu, "isSelect", shortcut, editOrderItemList, supportObj);
  });
}

function removeDiscountPanelInCustomPanel(discountPanelId, customPanel, selectProp, removedCustomPanel, removeFromList, supportObj) {
  if (!customPanel) {
    return;
  }
  let { selectedXChooseYPanelIdList, selectedDiscountPanelIdList, selectedTestIdList } = supportObj;
  let discountPanelIdList = customPanel.bundleItemList
  .filter(item => item.itemType === "official bundle")
  .map(item => item.itemId);
  let index = discountPanelIdList.indexOf(discountPanelId);
  // if current custom panel includes discountPanel
  if (index > -1) {
    // de-select current custom panel from selectedCustomPanelList
    customPanel[selectProp] = false;
    // remove current custom panel
    removeItem(removedCustomPanel, removeFromList);
    // add remaining xChooseYbundles
    customPanel.selectedXChooseYPanelList.forEach(panel => {
      selectedXChooseYPanelIdList.push(panel.bundleId);
      // delete current xChooseY panel's id from discountpanelIdList
      let panelIndex = discountPanelIdList.indexOf(panel.bundleId);
      discountPanelIdList.splice(panelIndex, 1);
    });
    // add all remaining discount panels to selectedDiscountPanelList
    discountPanelIdList.splice(index, 1);
    discountPanelIdList.forEach(panelId => {
      selectedDiscountPanelIdList.push(panelId);
    });
    // add current custom panel's test to selectedTestList
    let testIdList = customPanel.bundleItemList
      .filter(item => item.itemType !== "official bundle")
      .map(item => item.itemId);
    testIdList.forEach(testId => {
      selectedTestIdList.push(testId);
    });
  }
}

function removeDiscountPanelInShortcut(discountPanelId, shortcut, selectProp,  removedShortcut, removeFromList, supportObj) {
  if (!shortcut) {
    return;
  }
  let { selectedTestIdList, selectedCustomPanelIdList, selectedXChooseYPanelIdList, selectedDiscountPanelIdList, bundleList } = supportObj;
  let { testIdList, discountPanelIdList, customPanelIdList, selectedXChooseYPanelList } = shortcut;
  let index = discountPanelIdList.indexOf(discountPanelId);
  if (index > -1) {
    // de-select & remove current shortcut
    shortcut[selectProp] = false;
    removeItem(removedShortcut, removeFromList);
    // add test to selected list
    testIdList.forEach(id => {
      selectedTestIdList.push(id);
    });
    // add custom panels to selected list
    customPanelIdList.forEach(panelId => {
      selectedCustomPanelIdList.push(panelId);
    });
    // add xChooseY panels to selected list
    if (selectedXChooseYPanelList) {
      selectedXChooseYPanelList.filter(p => !p.customPanelId).forEach(xChooseY => {
        selectedXChooseYPanelIdList.push(xChooseY.bundleId);
      });
    }
    // add remaining discount panels to selected list
    let remainingDiscountPanelIds = [...discountPanelIdList];
    remainingDiscountPanelIds.splice(index, 1);
    remainingDiscountPanelIds.forEach(panelId => {
      selectedDiscountPanelIdList.push(panelId);
    });
  }
  else {
    // check whether it belongs any of current shortcut's custom panels
    let customPanelList = bundleList.filter(bundle => customPanelIdList.includes(bundle.bundleId));
    let remainingCustomPanelIdList = [];
    customPanelList.forEach(customPanel => {
      let discountPanelIdList = customPanel.bundleItemList
        .filter(item => item.itemType === "official bundle")
        .map(item => item.itemId);
      let discountPanelIndex = discountPanelIdList.indexOf(discountPanelId);
      // if current custom panel includes discountPanel
      if (discountPanelIndex > -1) {
        // de-select & remove current shortcut
        shortcut[selectProp] = false;
        // remove current custom panel
        removeItem(removedShortcut, removeFromList);
        // add remaining xChooseYbundles
        customPanel.selectedXChooseYPanelList.forEach(panel => {
          selectedXChooseYPanelIdList.push(panel.bundleId);
          // delete current xChooseY panel's id from discountpanelIdList
          let panelIndex = discountPanelIdList.indexOf(panel.bundleId);
          discountPanelIdList.splice(panelIndex, 1);
        });
        // add all remaining discount panels to selectedDiscountPanelList
        discountPanelIdList.splice(discountPanelIdList, 1);
        discountPanelIdList.forEach(panelId => {
          selectedDiscountPanelIdList.push(panelId);
        });
        // add current custom panel's test to selectedTestList
        let testIdList = customPanel.bundleItemList
          .filter(item => item.itemType !== "official bundle")
          .map(item => item.itemId);
        testIdList.forEach(testId => {
          selectedTestIdList.push(testId);
        });
      }
      else {
        remainingCustomPanelIdList.push(customPanel.bundleId);
      }
    });
    // if discount panel belongs to any of current shortcut's custom panels
    if (remainingCustomPanelIdList.length < customPanelList.length) {
      // add remaining custom panels
      remainingCustomPanelIdList.forEach(id => {
        selectedCustomPanelIdList.push(id);
      });
      // add discount panels
      discountPanelIdList.forEach(id => {
        selectedDiscountPanelIdList.push(id);
      });
      // add xChooseY panels
      if (selectedXChooseYPanelList) {
        selectedXChooseYPanelList.filter(xChooseY => !xChooseY.customPanelId)
          .forEach(xChooseY => {
            selectedXChooseYPanelIdList.push(xChooseY.bundleId);
          });
      }
      // add tests
      testIdList.forEach(id => {
        selectedTestIdList.push(id);
      });
    }
  }
}

// get all test ids in the given discount or custom panel
export function getTestIdsInPanel(panelId, bundleList, panelCategory) {
  if (!panelId) {
    return [];
  }
  let panel = bundleList.find(b => b.bundleId.toString() === panelId.toString());
  if (panel) {
    if (panelCategory === "discountPanel") {
      return getTestIdsInDiscountPanel(panel);
    }
    if (panelCategory === "customPanel") {
      let { bundleItemList } = panel;
      let testIdList = bundleItemList.filter(item => item.itemType !== "official bundle")
        .map(item => item.itemId);
      let officalPanelIds = bundleItemList.filter(item => item.itemType === "official bundle")
        .map(item => item.itemId);
      let officalPanelList = bundleList.filter(bundle => officalPanelIds.includes(bundle.bundleId));
      officalPanelList.forEach(panel => {
        testIdList.push(...getTestIdsInDiscountPanel(panel));
      });

      return [...new Set(testIdList)];
    }
  }
  return [];
}

function getTestIdsInDiscountPanel(panel) {
  if (!panel) {
    return [];
  }
  let { packageList, testList } = panel.bundleContent;
  let idList = (packageList ? packageList.map(p => p.packageId) : [])
      .concat(testList ? testList.map(t => t.testId): []);
  return [...new Set(idList)];
}

function isBundleInSelectedShortcut(panelId, supportObj) {
  let { shortcutList, selectedShortcutIdList, bundleList } = supportObj;
  let selectedShortcuts = shortcutList.filter(s => selectedShortcutIdList.includes(s.id));
  return selectedShortcuts.some(shortcut => {
    if (shortcut.discountPanelIdList && shortcut.discountPanelIdList.includes(panelId)) {
      return true;
    }
    if (shortcut.customPanelIdList) {
      return shortcut.customPanelIdList.some(customPanelId => {
        let customPanel = bundleList.find(b => b.bundleId === customPanelId);
        if (customPanel && customPanel.bundleItemList) {
          return customPanel.bundleItemList.some(
            item => item.itemType === "official bundle" && item.itemId === panelId
          );
        }
        return false;
      });
    }
    return false;
  });
}

function isBundleInSelectedCustomPanel(panelId, supportObj) {
  let { bundleList, selectedCustomPanelIdList } = supportObj;
  let selectedCustomPanels = bundleList.filter(b => selectedCustomPanelIdList.includes(b.bundleId));
  return selectedCustomPanels.some(customPanel => {
    if (customPanel.bundleItemList) {
      return customPanel.bundleItemList.some(
        item => item.itemType === "official bundle" && item.itemId === panelId
      );
    }
    return false;
  });
}